const API_BASE = process.env.LILAX_SERVICES_API;

export const lilaxService = {
  zodiac: `${API_BASE}/services/v1/zodiac`,
  weather: `${API_BASE}/services/v1/weather`,
};